export const config = {
  rowSelection: false,
  fieldControl: false,
  pagination: false,
  columns: [
    {
      title: '分类名称',
      dataIndex: ['object', 'cateName'],
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '创建人',
      dataIndex: ['object', 'createdByName'],
      width: 160,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '创建时间',
      dataIndex: ['object', 'createdTime'],
      itemType: 'dateTime',
      width: 160,
      ellipsis: {
        showTitle: true,
      },
    },
    {title: '状态', dataIndex: ['object', 'enabled'], width: 160, render: 'switchRender'},
    {
      title: '操作',
      dataIndex: 'actions',
      width: 180,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
  ],
  footer: [
    {
      label: '新增',
      // auth: 'priceButton1',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
  batchActions: [
  ],
}
